import moment from "moment";
import BaseDate from "./base_date";

import { partition } from "../lib/collection_helpers";

const allSorted = ["y", "M", "d", "w", "h", "m", "s"];
const allPeriods = new Set(["y", "M", "d", "w"]);
const dateFragsRegex = /(\d+)(\w)/g;

function recursiveRegexCapture(input, regex) {
  let ms = [];
  let match;

  while ((match = regex.exec(input)) !== null) {
    ms.push(match);
  }

  return ms;
}

function dateFragCapture(str) {
  return recursiveRegexCapture(str, dateFragsRegex).map((m) => ({
    unit: m[2],
    num: parseInt(m[1], 10),
  }));
}

export default class Duration extends BaseDate {
  constructor(fragments, timezone = "Etc/UTC") {
    super();

    this.fragments = fragments;
    this.fragments.sort(
      (a, b) => allSorted.indexOf(a.unit) - allSorted.indexOf(b.unit),
    );

    this.date = moment().subtract(moment.duration(this.param));
    this.timezone = timezone;
  }

  dup() {
    const dur = new Duration(this.fragments, this.timezone);
    dur.date = this.date.clone();
    return dur;
  }

  static fromInput(str) {
    const trimStr = str.replace(/ /g, "");
    const frags = dateFragCapture(trimStr);

    return new Duration(frags);
  }

  static fromParam(str) {
    if (str === "" || str === null || str === undefined) {
      return new Duration([]);
    }

    const matches = str.toLowerCase().match(/p([^t]*)t?(.*)?/);
    if (matches === null) {
      return new Duration([]);
    }

    let fragments = [];
    if (matches[1] !== "" && matches[1] !== undefined) {
      const frags = dateFragCapture(matches[1]);
      frags.forEach((e) => {
        if (e.unit === "m") {
          e.unit = "M";
        }
      });
      fragments.push(...frags);
    }
    if (matches[2] !== "" && matches[2] !== undefined) {
      fragments.push(...dateFragCapture(matches[2]));
    }

    return new Duration(fragments);
  }

  valid() {
    const durSeconds = moment.duration(this.param).asSeconds();

    if (durSeconds === 0 || durSeconds === null || isNaN(durSeconds)) {
      return false;
    } else {
      return true;
    }
  }

  get param() {
    const [periods, times] = partition(this.fragments, (v) =>
      allPeriods.has(v.unit),
    );

    let f = "P";
    if (periods.length) {
      const u = periods.map(({ unit, num }) => `${num}${unit}`).join("");
      f = `${f}${u}`;
    }
    if (times.length) {
      const u = times.map(({ unit, num }) => `${num}${unit}`).join("");
      f = `${f}T${u}`;
    }

    return f.toUpperCase();
  }

  get output() {
    return this.fragments
      .map(
        ({ unit, num }) => `${num}${unit == "M" ? unit : unit.toLowerCase()}`,
      )
      .join("");
  }
}
